import useMutationCall from "../../../hooks/useMutationCall";
import { usePatchActivityMutation } from "../timelogsSlice";

const usePatchActivity = () => {
  return useMutationCall(usePatchActivityMutation);
};

export default usePatchActivity;